export type Level = "debug" | "info" | "warn" | "error";

export const LEVELS: Record<Level, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

export const levels = {
  gte(a: Level, b: Level): boolean {
    return LEVELS[a] >= LEVELS[b];
  },
};

const LEVEL_VALUES: Level[] = ["debug", "info", "warn", "error"];

export function isLevel(level: string): level is Level {
  return LEVEL_VALUES.some((candidate) => candidate === level);
}

// Generate level options for UI components
export const levelOptions = LEVEL_VALUES.map((level) => ({
  value: level,
  label: level.charAt(0).toUpperCase() + level.slice(1),
  aliases: Array<string>(),
}));
